__turbopack_context__.v({
  "actionButton": "styles-module-scss-module__gYABnW__actionButton",
  "actionButtons": "styles-module-scss-module__gYABnW__actionButtons",
  "appraiseButton": "styles-module-scss-module__gYABnW__appraiseButton",
  "badge": "styles-module-scss-module__gYABnW__badge",
  "body": "styles-module-scss-module__gYABnW__body",
  "brandBar": "styles-module-scss-module__gYABnW__brandBar",
  "brandInfo": "styles-module-scss-module__gYABnW__brandInfo",
  "brandTitle": "styles-module-scss-module__gYABnW__brandTitle",
  "buttonContainer": "styles-module-scss-module__gYABnW__buttonContainer",
  "buyButton": "styles-module-scss-module__gYABnW__buyButton",
  "buyButtonLabel": "styles-module-scss-module__gYABnW__buyButtonLabel",
  "cardContainer": "styles-module-scss-module__gYABnW__cardContainer",
  "carouselContainer": "styles-module-scss-module__gYABnW__carouselContainer",
  "container": "styles-module-scss-module__gYABnW__container",
  "couponCode": "styles-module-scss-module__gYABnW__couponCode",
  "couponDetail": "styles-module-scss-module__gYABnW__couponDetail",
  "couponExpiry": "styles-module-scss-module__gYABnW__couponExpiry",
  "couponItem": "styles-module-scss-module__gYABnW__couponItem",
  "coupons": "styles-module-scss-module__gYABnW__coupons",
  "fallbackActions": "styles-module-scss-module__gYABnW__fallbackActions",
  "favoriteButton": "styles-module-scss-module__gYABnW__favoriteButton",
  "favoriteSection": "styles-module-scss-module__gYABnW__favoriteSection",
  "favoriteText": "styles-module-scss-module__gYABnW__favoriteText",
  "followButton": "styles-module-scss-module__gYABnW__followButton",
  "followSection": "styles-module-scss-module__gYABnW__followSection",
  "h2NotBold": "styles-module-scss-module__gYABnW__h2NotBold",
  "imageColumn": "styles-module-scss-module__gYABnW__imageColumn",
  "imageContainer": "styles-module-scss-module__gYABnW__imageContainer",
  "loading": "styles-module-scss-module__gYABnW__loading",
  "loadingContainer": "styles-module-scss-module__gYABnW__loadingContainer",
  "locationRow": "styles-module-scss-module__gYABnW__locationRow",
  "locationText": "styles-module-scss-module__gYABnW__locationText",
  "price": "styles-module-scss-module__gYABnW__price",
  "priceBar": "styles-module-scss-module__gYABnW__priceBar",
  "priceRow": "styles-module-scss-module__gYABnW__priceRow",
  "priceSection": "styles-module-scss-module__gYABnW__priceSection",
  "priceValue": "styles-module-scss-module__gYABnW__priceValue",
  "productBreadcrumb": "styles-module-scss-module__gYABnW__productBreadcrumb",
  "productHeaderActions": "styles-module-scss-module__gYABnW__productHeaderActions",
  "productPage": "styles-module-scss-module__gYABnW__productPage",
  "proxyCaption": "styles-module-scss-module__gYABnW__proxyCaption",
  "proxyGuideLink": "styles-module-scss-module__gYABnW__proxyGuideLink",
  "proxyOptionsBtn": "styles-module-scss-module__gYABnW__proxyOptionsBtn",
  "recommendationsContainer": "styles-module-scss-module__gYABnW__recommendationsContainer",
  "region": "styles-module-scss-module__gYABnW__region",
  "saveButton": "styles-module-scss-module__gYABnW__saveButton",
  "sizeLink": "styles-module-scss-module__gYABnW__sizeLink",
  "sizeSection": "styles-module-scss-module__gYABnW__sizeSection",
  "sold": "styles-module-scss-module__gYABnW__sold",
  "stats": "styles-module-scss-module__gYABnW__stats",
  "stickyHeader": "styles-module-scss-module__gYABnW__stickyHeader",
  "stickyHeaderLeft": "styles-module-scss-module__gYABnW__stickyHeaderLeft",
  "stickyHeaderRow": "styles-module-scss-module__gYABnW__stickyHeaderRow",
  "text": "styles-module-scss-module__gYABnW__text",
  "timeSince": "styles-module-scss-module__gYABnW__timeSince",
  "translateButton": "styles-module-scss-module__gYABnW__translateButton",
  "vendorInfo": "styles-module-scss-module__gYABnW__vendorInfo",
  "vendorLink": "styles-module-scss-module__gYABnW__vendorLink",
  "vendorRow": "styles-module-scss-module__gYABnW__vendorRow",
  "warningBadge": "styles-module-scss-module__gYABnW__warningBadge",
});
